// extracted by mini-css-extract-plugin
module.exports = {"sloganColor":"#686868","progressBarColor":"#b0b0b0"};